import Vue from 'vue'
import Element from 'element-ui'
// import '../element-variables.scss'
import '../scss/base/_common.scss'
import '../scss/base/_reset.scss'
import '../element-variables.scss'
// 引入rem
import '@/utils/rem'

Vue.use(Element)



// WEBPACK FOOTER //
// ./src/plugins/element.js